import React from 'react';
import cn from 'classnames';
import Slider from '@dealroadshow/uikit-slider';
import useIntersectionObserver from '@framework/hooks/useIntersectionObserver';
import { feedbacksList as defaultFeedbacksList, slidersSettingsTypes } from './feedbacksConfig';
import { IFeedback } from './interfaces';
import cardStyles from '@dealroadshow/uikit-styles/card.module.scss';
import shadowStyles from '@dealroadshow/uikit-styles/helpers/shadowOnHover.module.scss';
import styles from './feedbacks.module.scss';

interface IProps {
  className?: string,
  feedbackClassName?: string,
  sliderType?: keyof typeof slidersSettingsTypes,
  cardStyle?: 'default' | 'modern',
  feedbacksList?: IFeedback[],
  imageComponent?: React.ComponentType<any>,
}

const Feedbacks = ({
  className,
  feedbackClassName,
  sliderType = 'default',
  cardStyle = 'default',
  feedbacksList = defaultFeedbacksList,
  imageComponent: ImageComponent,
}: IProps) => {
  const { wrapperClassName, ...sliderSettings } = slidersSettingsTypes[sliderType];
  const { containerRef, isIntersected } = useIntersectionObserver([], { rootMargin: '200px' });

  return (
    <div ref={ containerRef } className={ cn(styles.feedbacks, className) }>
      <div className={ styles.feedbacksWrp }>
        { isIntersected && (
          <Slider
            className={ styles.sliderFeedbacks }
            wrapperClassName={ cn(styles.wrapperSliderFeedbacks, wrapperClassName) }
            collection={ feedbacksList }
            getItemKey={ (feedback: IFeedback) => feedback.feedbackText }
            options={ sliderSettings }
            renderItem={ ({ imageSrc, imageAlt, feedbackText, feedbackAuthor, imageWidth, imageHeight }: IFeedback) => (
              <div className={ cn(styles.feedback, feedbackClassName) }>
                <div
                  className={ cn(
                    styles.feedbackCard,
                    {
                      [cardStyles.cardContainer]: cardStyle === 'default',
                      [shadowStyles.darkShadowOnHover]: cardStyle === 'default',
                      [styles.modernCard]: cardStyle === 'modern',
                    },
                  ) }
                >
                  <div className={ styles.feedbackLogo }>
                    { ImageComponent ? (
                      <ImageComponent
                        src={ imageSrc }
                        title={ imageAlt }
                        alt={ imageAlt }
                        width={ imageWidth }
                        height={ imageHeight }
                      />
                    ) : (
                      <img
                        src={ imageSrc }
                        title={ imageAlt }
                        alt={ imageAlt }
                      />
                    ) }
                  </div>
                  <div className={ styles.feedbackText }>
                    { feedbackText }
                  </div>
                  <div className={ styles.feedbackAuthor }>
                    { feedbackAuthor }
                  </div>
                </div>
              </div>
            ) }
          />
        ) }
      </div>
    </div>
  );
};

export default Feedbacks;
